export const TRANSFER_CONSTANTS = {
  button: {
    label: "Start Free Trial",
    link: "#contact-us",
    btn2: {
      label: "Schedule A Demo",
      link: "#contact-us",
    },
  },
  content:
    "Get started with OneMind’s Managed OpenStack today and experience enterprise-grade cloud management",
  title: "Ready to transfer your Cloud Infrastructure?",
};
